import Metrics from '../../components/dashboard/UlwaziMetrics';
import PageMeta from '../../components/common/PageMeta';

export default function Dashboard() {
  return (
    <>
      <PageMeta title="Pfunzo Home" description="Pfunzo Home" />
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-12 space-y-6">
          <Metrics />
        </div>
      </div>
    </>
  );
}
